import { jsx } from "react/jsx-runtime";
import RedoIcon from "@mui/icons-material/Redo";
import { validateTidalLicense } from "../../base/index.js";
function Redo(props) {
  return /* @__PURE__ */ jsx(
    RedoIcon,
    {
      "data-testid": "Redo",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Redo",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
Redo.tidalIconMeta = {
  categories: "arrows",
  name: "Redo"
};
validateTidalLicense();
export {
  Redo
};
//# sourceMappingURL=Redo.js.map
